import { LifecycleTemplate, SharedThing } from '@eagle/core-data-types';

export const selectHighestPriorityStakeholderRoles = (
  stakeholderRoles: string[],
  lifecycleTemplate: LifecycleTemplate,
  sharedThing?: SharedThing,
  isSelfClaim = false,
): string[] => {
  if (stakeholderRoles.length === 0) {
    return [];
  }

  let rolesToConsider = stakeholderRoles;

  if (sharedThing) {
    const currentStageId = sharedThing.lifecycleState?.stageId;
    if (currentStageId) {
      const currentStage = lifecycleTemplate.stages.find((s) => s.stageId === currentStageId);
      if (currentStage?.stakeholders) {
        const stageStakeholders = currentStage.stakeholders;
        const stageStakeholderRoles = Object.keys(stageStakeholders);
        const normalizedRoles = stageStakeholderRoles.map((role) => role.toLowerCase());

        rolesToConsider = stakeholderRoles.filter((role) => normalizedRoles.includes(role.toLowerCase()));

        if (isSelfClaim) {
          const selfClaimRoles = stageStakeholderRoles
            .filter((role) => Boolean(stageStakeholders[role]?.selfClaim))
            .map((role) => role.toLowerCase());

          const filteredSelfClaimRoles = rolesToConsider.filter((role) => selfClaimRoles.includes(role.toLowerCase()));

          if (filteredSelfClaimRoles.length > 0) {
            rolesToConsider = filteredSelfClaimRoles;
          }
        }
      }
    }
  }

  const rolesWithPriorities = rolesToConsider
    .map((role) => ({
      role: role.toLowerCase(),
      priority: lifecycleTemplate.stakeholderAccounts[role.toLowerCase()]?.installationPriority ?? -1,
    }))
    .filter((r) => r.priority >= 0);

  if (rolesWithPriorities.length === 0) {
    return rolesToConsider.map((role) => role.toLowerCase());
  }

  const sortedRoles = rolesWithPriorities.sort((a, b) => b.priority - a.priority);
  const highestPriority = sortedRoles[0].priority;

  return sortedRoles
    .filter((role) => role.priority === highestPriority)
    .map((role) => role.role);
};
